export default function HomePage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#19001a' }}>
      <h1 style={{ color: '#fff', fontSize: '2.5rem', textAlign: 'center' }}>Coming soon</h1>
    </div>
  );
}
